import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ListGroup from "./listGroup";

const InputAndSelect = ({
  name,
  label,
  error,
  icon,
  options,
  valueProperty,
  textProperty,
  value,
  onChange,
  onSelectChange,
}) => {
  const [listActive, setListActive] = useState(false);
  const [focus, setFocus] = useState(false);

  const handleClick = () => {
    console.info("click");
    const active = !listActive;
    setListActive(active);
    if (active) setFocus(true);
    else setFocus(false);
  };

  const handleSelect = (item) => {
    console.info("name, item...", name, item[valueProperty]);
    onSelectChange(name, item[valueProperty]);
    setListActive(false);
  };

  const handleFocus = () => {
    setFocus(!focus);
  };

  return (
    <>
      <label className="fa fa-plane" htmlFor={name}>
        {icon && <FontAwesomeIcon icon={icon} />}&nbsp;{label}
      </label>
      <div
        className={
          focus ? "inputAndSelectContainerFocus" : "inputAndSelectContainer"
        }
      >
        <input
          onChange={onChange}
          name={name}
          id={name}
          className="inputForInputAndSelect"
          value={value}
          onFocus={handleFocus}
          onBlur={handleFocus}
        />
        <span onClick={handleClick} style={{ marginTop: "5px" }}>
          <FontAwesomeIcon icon={listActive ? "chevron-up" : "chevron-down"} />
        </span>
      </div>
      {listActive && (
        <ListGroup
          name="list"
          items={options}
          valueProperty={valueProperty}
          textProperty={textProperty}
          selectedItem={value}
          onItemSelect={handleSelect}
        />
      )}
    </>
  );
};
export default InputAndSelect;
